// src/components/TopNavBar.js
import { useState, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { trackClickEvent } from "../utils/analytics";
import logo from "../assets/images/strobelogo.svg";

export default function TopNavBar({ isMenuOpen, toggleMenu }) {
  const location = useLocation();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const timeoutRef = useRef(null);

  const handleNavClick = (label) => {
    trackClickEvent(`Nav Click: ${label}`);
    toggleMenu(false);
  };

  const showDropdown = () => {
    clearTimeout(timeoutRef.current);
    setIsDropdownOpen(true);
  };

  const hideDropdown = () => {
    timeoutRef.current = setTimeout(() => setIsDropdownOpen(false), 200);
  };

  return (
    <header className="fixed top-0 left-0 w-full z-50 backdrop-blur-lg bg-white/20 shadow-[0_4px_30px_rgba(0,0,0,0.25)] text-white">
  <div className="flex justify-between items-center px-6 md:px-8 py-2">

        {/* Logo */}
        <Link
          to="/"
          onClick={() => trackClickEvent("Logo Click")}
          className="z-50"
        >
          <img src={logo} alt="Strobe Logo" className="w-44 h-auto" />
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex gap-10 items-center font-body font-regular text-md tracking-wide relative">
          <Link
            to="/about"
            onClick={() => handleNavClick("About")}
            className="hover:text-strobe-red transition"
          >
            ABOUT
          </Link>
         <div>
            <Link
              to="/services"
              onClick={() => handleNavClick("Services")}
              className="hover:text-strobe-red transition"
            >
              SERVICES
            </Link>
          </div>

          <Link
            to="/media"
            onClick={() => handleNavClick("Media")}
            className="hover:text-strobe-red transition"
          >
            PORTFOLIO
          </Link>
          <Link
            to="/contact"
            onClick={() => handleNavClick("Contact")}
            className="hover:text-strobe-red transition"
          >
            CONTACT
          </Link>
          <div className="flex gap-3">
            <Link to="/login" onClick={() => trackClickEvent("Header: Login")} className="px-4 py-2 bg-[#0D0D0D] text-white rounded-lg hover:bg-[#FF000A] transition">LOGIN</Link>
          </div>
        </nav>

        {/* Mobile Toggle */}
        <button
          onClick={toggleMenu}
          className="md:hidden text-white z-50"
          aria-label="Toggle Menu"
        >
          {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="md:hidden absolute top-full left-0 w-full backdrop-blur-lg bg-strobe-black/95 border-t border-white/20 shadow-[0_4px_30px_rgba(0,0,0,0.25)] py-6 px-4 text-center space-y-5 z-40">
          <Link
            to="/about"
            onClick={() => handleNavClick("About")}
            className="block text-lg font-medium text-white hover:text-strobe-red transition"
          >
            About
          </Link>
          <Link
            to="/services"
            onClick={() => handleNavClick("Services")}
            className="block text-lg font-medium text-white hover:text-strobe-red transition"
          >
            Services
          </Link>
          <Link
            to="/media"
            onClick={() => handleNavClick("Media")}
            className="block text-lg font-medium text-white hover:text-strobe-red transition"
          >
            Media
          </Link>
          <Link
            to="/contact"
            onClick={() => handleNavClick("Contact")}
            className="block text-lg font-medium text-white hover:text-strobe-red transition"
          >
            Contact
          </Link>
          <Link
            to="/login"
            onClick={() => handleNavClick("Login")}
            className="block w-full py-2 bg-strobe-red text-strobe-white font-semibold rounded-lg hover:bg-strobe-red hover:text-white transition"
          >
            Login
          </Link>
        </div>
      )}
    </header>
  );
}
